import { RefObject, useLayoutEffect, useState } from "react";
import styles from "./Brugere.module.scss";
import brugerApi from "@/api/bruger";
import rolleApi from "@/api/rolle";
import { BrugerePageOptions } from "@/interfaces/paging";
import { useSearchParams } from "react-router-dom";
import BrugerList from "./BrugerList";
import Bruger from "./Bruger";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useScrollRestoration from "@/hooks/useScrollRestoration";
import { BrugerSortOrder } from "@/interfaces/Opgaveliste/enums";

export default function Brugere(props: {
  scrollRef: RefObject<HTMLDivElement | null>;
}) {
  const [searchParams] = useSearchParams();
  const brugerid = searchParams.get("brugerid");
  // const sortOrder = searchParams.get("sortOrder");
  const [showFilter, setShowFilter] = useState(false);
  const [inputBrugernavn, setInputBrugernavn] = useState("");
  const [inputKommunenr, setInputKommunenr] = useState("");
  const [inputRolleid, setInputRolleid] = useState("");
  const pageSize = import.meta.env.VITE_OPGAVE_PAGE_SIZE
    ? parseInt(import.meta.env.VITE_OPGAVE_PAGE_SIZE)
    : 50;

  const [pageOptions, setPageOptions] = useState<BrugerePageOptions>({
    page: 1,
    pageSize,
    navn: "",
    kommunenr: "",
    sortOrder: BrugerSortOrder.NavnAsc,
    rolleid: "",
  });

  const { restoreScroll } = useScrollRestoration(
    "admin?type=brugere&page=" + pageOptions.page,
    props.scrollRef
  );
  const [totalCount, setTotalCount] = useState(0);

  const { page, id, navn, kommunenr, sortOrder, rolleid } = pageOptions;
  const { data } = useQuery({
    queryKey: ["brugere", page, id, navn, kommunenr, sortOrder, rolleid],
    queryFn: async () => {
      const ol = await brugerApi.getAllWithHeaders(pageOptions);
      const listContentRange = ol.headers["list-content-range"];
      const tc = parseInt(listContentRange.split("/")[1]);
      setTotalCount(tc);
      return ol.data;
    },
  });

  useLayoutEffect(() => {
    setTimeout(() => {
      restoreScroll();
    }, 300);
  }, [data, restoreScroll]);

  const { data: roller } = useQuery({
    queryKey: ["roller"],
    queryFn: async () => {
      return await rolleApi.getAll();
    },
  });
  const queryClient = useQueryClient();
  const updateBruger = (_bruger: Bruger) => {
    queryClient.invalidateQueries();
  };
  return (
    <div className={styles.container}>
      {!brugerid && (
        <BrugerList
          roller={roller ?? []}
          brugere={data ?? []}
          pageOptions={pageOptions}
          setPageOptions={setPageOptions}
          totalCount={totalCount}
          brugernavnFilter={pageOptions.navn}
          brugernavn={inputBrugernavn}
          setBrugernavn={setInputBrugernavn}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          kommunenrFilter={pageOptions.kommunenr}
          setKommunenr={setInputKommunenr}
          kommunenr={inputKommunenr}
          setRolleId={setInputRolleid}
          rolleId={inputRolleid}
        />
      )}
      {brugerid && (
        <Bruger
          roller={roller ?? []}
          brugerid={brugerid}
          bruger={data?.find((b) => b.id === brugerid)}
          updateBruger={updateBruger}
        />
      )}
    </div>
  );
}
